



































import Vue from 'vue';
import {searchPoi} from '@/store/api/search-poi';
import {POIOption} from './trip-inputs-helper';
import FilterInput from './filter-input.vue';
import Dropdown from '@common/dropdown/dropdown.vue';
import DropItem from './drop-item.vue';
import v4 from 'uuid/v4';

export type SearchType = 'from' | 'to';

export interface SearchValue {
  value: string;
  location: SearchType;
}

const StillLoadingItem = {
  name: 'LOOKING FOR SMTS',
  type: 'SEARCH',
  id: '',
  lat: 0,
  lng: 0,
};

const NotFoundItem = {
  name: '',
  type: 'NONE',
  id: '',
  lat: 0,
  lng: 0,
};

const getStillLoadingItem = () => ({...StillLoadingItem, id: v4()});

export default Vue.extend({
  name: 'LocationAutocomplete',
  props: {
    searchType: {
      type: String,
      default: () => 'from',
    },
    initialValue: {
      type: Object,
      default: () => null,
    },
    disabled: Boolean,
    locked: {
      type: Boolean,
      default: () => false,
    },
    excludeCountries: {
      type: Boolean,
      default: () => true,
    },
    label: {
      type: String,
      default: () => undefined,
    },
    noBorder: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    FilterInput,
    Dropdown,
    DropItem,
  },
  computed: {},
  data() {
    return {
      isLoading: false,
      location: this.initialValue ? this.initialValue : null,
      locationName: this.initialValue ? this.initialValue.name : '',
      locationOptions: [] as POIOption[],
    };
  },
  mounted() {
    // @ts-ignore
    this.onBodyClick = this.onBodyClick.bind(this);
    // @ts-ignore
    document.addEventListener('click', this.onBodyClick, false);
  },
  beforeDestroy() {
    // @ts-ignore
    document.removeEventListener('click', this.onBodyClick);
  },
  watch: {
    initialValue() {
      if (this.initialValue) {
        this.location = this.initialValue;
        this.locationName = this.initialValue.name;
      }
    },
  },
  methods: {
    getItemIcon(item: POIOption) {
      return item.type === 'airport' ? '--filter-airplane-icon' : '--filter-location-icon';
    },

    onLocationChange(value: string) {
      this.locationName = value;
    },

    async onInputChange(value: string) {
      this.isLoading = true;

      if (this.locationOptions.length === 0) {
        // set to three empty items, to make dropdown height more consistent
        this.locationOptions = [getStillLoadingItem(), getStillLoadingItem(), getStillLoadingItem()];
      }

      // @ts-ignore
      const options = (await this.searchLocation({value, location: this.searchType})) || [];
      this.isLoading = false;
      const ids = new Set();

      this.locationOptions = options.filter((item: POIOption) => {
        if (ids.has(item.id)) {
          return false;
        }

        // filter out countries
        if (this.excludeCountries && item.type === 'country') {
          return false;
        }

        ids.add(item.id);
        return true;
      });

      if (options.length === 0 && value) {
        this.locationOptions = [NotFoundItem];
      }
    },

    searchLocation(value: SearchValue): Promise<POIOption[]> {
      return searchPoi(value.value, value.location);
    },

    async onItemSelect(value: POIOption) {
      this.locationOptions = [];
      if (value.name && value.name !== 'LOOKING FOR SMTS') {
        this.location = value;
        this.locationName = value.name;
        this.$emit('location-selected', this.location);
      }
    },

    onBodyClick() {
      this.isLoading = false;
      this.locationOptions = [];
    },
  },
});
